module.exports = __webpack_public_path__ + "img/arrays.5d3a7aff.svg";